export function connectionReady(state) {
	return state.connection === 'ok'
}
